import { TimeBlockStructureService } from '../../../time-block-structure/time-block-structure.service';
import { CalendarService } from '../../../../../services/calendar.service';
import { TimeBlockIntersectionService } from '../../intersection/time-block-intersection.service';
import { ITimeBlockComponentItem } from '../../../types/time-block-component-item-types';
import { MonthCalendarModel } from '../../../../../../../core/models/calendar/month-calendar.model';
import { DateTimeHelper } from '../../../../../util/date-time-helper';
import { MonthViewSlotVectorService } from './month-view-slot-vector.service';
import { SlotMonthViewTimeBlockFacade } from '../slot/slot-month-view-time-block-facade';
import { Injectable, inject } from '@angular/core';
import { SlotHandlerService } from '../../../../../../../core/services/features/fix-interval-planner/slot-handler.service';
import { Interval } from 'date-fns';

@Injectable()
export class ParallelTimeBlockMonthViewCalculatorService {
  private readonly monthViewSlotVectorService = inject(MonthViewSlotVectorService);
  private readonly timeBlockStructureService = inject(TimeBlockStructureService);
  private readonly calendarService = inject(CalendarService);
  private readonly timeBlockIntersectionService = inject(TimeBlockIntersectionService);
  private readonly slotHandlerService = inject(SlotHandlerService);

  calculate(): ITimeBlockComponentItem[] {
    const calendarModel = (this.calendarService.model as MonthCalendarModel)
      .fixIntervalCalendarModel;
    const fullRange: Interval = {
      start: calendarModel.calendarProperties.visibleStartDate,
      end: calendarModel.calendarProperties.visibleEndDate,
    };
    const timeBlockMapFixInterval = this.timeBlockStructureService.getTimeBlockMap(true, fullRange);
    const fixIntervalTimeBlockHeadMap =
      this.timeBlockStructureService.getFixIntervalHeadParts(timeBlockMapFixInterval);
    const timeBlockMapVariableInterval = this.timeBlockStructureService.getTimeBlockMap(
      false,
      fullRange,
    );

    this.monthViewSlotVectorService.setStartDate$.next(fullRange.start as Date);

    // fill in fix interval time blocks first
    fixIntervalTimeBlockHeadMap.forEach(
      (fixIntervalTimeBlocksPerDay: ITimeBlockComponentItem[], date: string): void => {
        const slotsPerWeek = this.monthViewSlotVectorService.getSlotsPerWeek(
          DateTimeHelper.parseISO(date),
        );
        this.slotHandlerService.orderFixIntervalTimeBlocks(fixIntervalTimeBlocksPerDay);
        fixIntervalTimeBlocksPerDay.forEach((timeBlock: ITimeBlockComponentItem) => {
          this.slotHandlerService.assignTimeBlockToSlot(
            timeBlock,
            slotsPerWeek,
            this.timeBlockIntersectionService,
            true,
          );
        });
      },
    );

    // then fill slots with variable interval time blocks
    timeBlockMapVariableInterval.forEach(
      (variableIntervalTimeBlocksPerDay: ITimeBlockComponentItem[], dateString: string): void => {
        const date = DateTimeHelper.parseISO(dateString);
        const slotsPerWeek = this.monthViewSlotVectorService.getSlotsPerWeek(date);
        this.slotHandlerService.orderVariableIntervalTimeBlocksByStartDate(
          variableIntervalTimeBlocksPerDay,
        );
        variableIntervalTimeBlocksPerDay.forEach((timeBlock: ITimeBlockComponentItem) => {
          this.slotHandlerService.assignTimeBlockToSlot(
            SlotMonthViewTimeBlockFacade.fromITimeBlockComponentItem(
              timeBlock,
              DateTimeHelper.startOfDay(date),
              DateTimeHelper.startOfDay(date),
            ),
            slotsPerWeek,
            this.timeBlockIntersectionService,
            true,
          );
        });
      },
    );

    this.monthViewSlotVectorService.removeWrapper();
    return this.monthViewSlotVectorService.updateGeometry(
      this.slotHandlerService.updateGeometryHorizontalSlots,
    );
  }
}
